import { render, staticRenderFns } from "./object-group-item.vue?vue&type=template&id=a38f1776&scoped=true&"
import script from "./object-group-item.vue?vue&type=script&lang=js&"
export * from "./object-group-item.vue?vue&type=script&lang=js&"
import style0 from "./object-group-item.vue?vue&type=style&index=0&id=a38f1776&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38f1776",
  null
  
)

export default component.exports